import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`    
  #root {
    font-family : "Pretendard-Medium"
  }    
`;

export default GlobalStyle;
